import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { LitSquadInventoryEntry } from '@/lib/api';
import { isSafeImageUri, resolveLitSquadDisplayName, resolveLitSquadThumbnail } from '../utils';

interface AvatarEditorAccessoryChipProps {
  entry: LitSquadInventoryEntry;
  onRemove: (itemId: string) => void;
}

/**
 * Compact chip showing one accessory layered on the in-progress avatar,
 * with a remove control. The parent owns the layering order — chips are
 * rendered in the same order accessories were added.
 */
export function AvatarEditorAccessoryChip({ entry, onRemove }: AvatarEditorAccessoryChipProps) {
  const name = resolveLitSquadDisplayName(entry);
  const thumb = resolveLitSquadThumbnail(entry);
  const itemId = entry.itemId ?? '';

  return (
    <div className="flex items-center gap-2 rounded-md border bg-card px-2 py-1 text-xs">
      <div className="h-8 w-8 overflow-hidden rounded-sm bg-muted">
        {isSafeImageUri(thumb) ? (
          <img src={thumb!} alt="" className="h-full w-full object-cover" />
        ) : null}
      </div>
      <span className="max-w-[10rem] truncate" title={name}>
        {name}
      </span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-5 w-5 p-0"
        onClick={() => onRemove(itemId)}
        aria-label={`Remove ${name} from avatar`}
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
}
